import { PDFDocument } from "pdf-lib";
import api from "../../api";
import { generateDocumentPdf } from "../../services/documentPdfService";
import {
  exactRenderEndpoint,
  isExactPdfTemplate,
} from "../documentTemplateExactMode";
const safeName = (value) =>
  String(value || "documento")
    .replace(/[\\/:*?"<>|\x00-\x1f]/g, "-")
    .slice(0, 130);
export async function preparePersonSignatureFile({
  templates,
  person,
  variables,
  kind,
  cleanHtml = (value) => value,
  instance,
}) {
  if (!person || !templates?.length)
    throw new Error("Selecione uma pessoa e um modelo de documento.");
  const blobs = [];
  for (const template of templates) {
    if (isExactPdfTemplate(template)) {
      const response = await api.post(
        exactRenderEndpoint(kind, template.id),
        { values: variables.values },
        { responseType: "blob" },
      );
      blobs.push(response.data);
    } else {
      const generated = await generateDocumentPdf({
        field: {
          id: String(template.id || "documento"),
          label: template.name,
          documentTemplate: {
            title: template.title,
            content: cleanHtml(template.content),
          },
        },
        fields: variables.fields,
        values: variables.values,
        instance: instance || { id: String(person.id) },
        outputOnly: true,
        save: false,
      });
      const blob = generated?.blob || generated?.doc?.output?.("blob");
      if (!blob)
        throw new Error("Não foi possível gerar o PDF para assinatura.");
      blobs.push(blob);
    }
  }
  let bytes;
  if (blobs.length === 1) bytes = await blobs[0].arrayBuffer();
  else {
    const merged = await PDFDocument.create();
    for (const blob of blobs) {
      const raw = new Uint8Array(await blob.arrayBuffer());
      let marker = "";
      for (let n = 0; n < raw.length; n += 8192)
        marker += String.fromCharCode(...raw.subarray(n, n + 8192));
      if (/\/ByteRange\s*\[/.test(marker))
        throw new Error(
          "Um documento já assinado deve ser enviado separadamente, preservando as assinaturas anteriores.",
        );
      const pdf = await PDFDocument.load(raw);
      for (const page of await merged.copyPages(pdf, pdf.getPageIndices()))
        merged.addPage(page);
    }
    bytes = await merged.save();
  }
  return new File(
    [bytes],
    `${safeName(templates.length === 1 ? templates[0].name : "Documentos")}-${safeName(person.fullName)}.pdf`,
    { type: "application/pdf" },
  );
}
